import React from "react";
import { styled } from "@mui/system";
import FriendsTitle from "./FriendsTitle";
import FriendsList from "./FriendsList/FriendsList";

const MainContainer = styled("div")({
  width: "224px",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  backgroundColor: "#17181b",
});

const SearchBox = styled("div")({
  width: "calc(100% - 20px)",
  height: "32px",
  margin: "10px 10px 0",
  borderRadius: "6px",
  backgroundColor: "#111214",
  color: "#b5bac1",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "13px",
  fontWeight: 700,
});

const FriendsSidebar = () => {
  return (
    <MainContainer>
      <SearchBox>Найти или начать беседу</SearchBox>
      <FriendsTitle title="Личные сообщения" />
      <FriendsList />
    </MainContainer>
  );
};

export default FriendsSidebar;
